import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import { makeStyles, IconButton, SvgIcon, Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import PermissionsGate from 'src/components/PermissionsGate';
import { SCOPES } from 'src/constants/roles';

const useStyles = makeStyles(theme => ({
  NavBarItem: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '10px',
    marginTop: '5px',
    backgroundColor: theme.palette.background.default,
    boxSizing: 'border-box',
    width: '60px',
    height: '60px',
    borderRadius: '12px',
    textAlign: 'center',
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: "theme.palette.action.hover",
      borderRadius: '12px',
    },
    '&.active': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  active: {
    backgroundColor: 'black',
    color: 'white',
  },
  NavBarItemIcon: {
    fontSize: '1.2rem',
  },
  NavBarItemText: {
    fontSize: '0.6rem',
    marginTop: '4px',
    color: theme.palette.text.primary,
  },
}));

export default function NavBarItem({ icon, title, href, click, active }) {
  const Icon = icon;
  const classes = useStyles();

  const Content = (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <SvgIcon className={classes.NavBarItemIcon}>
        <Icon />
      </SvgIcon>
      <Typography className={classes.NavBarItemText}>{title}</Typography>
    </div>
  );

  const isRestricted = (href && href.includes('actions')) || (href && href.includes('llm-playground'));

  if (isRestricted) {
    return (
      <PermissionsGate
        section="studio"
        scopes={[SCOPES.canUse]}
        errorProps={{ to: '#' }}
      >
        <RouterLink className={classes.NavBarItem} to={href}>
          <PermissionsGate
            section="studio"
            scopes={[SCOPES.canUse]}
            errorProps={{ disabled: true }}
          >
            <IconButton onClick={click} style={{ flexDirection: 'column' }}>
              {Content}
            </IconButton>
          </PermissionsGate>
        </RouterLink>
      </PermissionsGate>
    );
  } else {
    return (
      <RouterLink className={classes.NavBarItem} to={href}>
        <IconButton onClick={click} style={{ flexDirection: 'column' }}>
          {Content}
        </IconButton>
      </RouterLink>
    );
  }
}
